var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#140e38",
    d: "M20,76.67v6.663C20,86.999,23.002,90,26.666,90h46.667C76.999,90,80,86.999,80,83.333V76.67H20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e38",
    d: "M73.333,36.666H70V30c0-11.045-8.955-20-20-20s-20,8.955-20,20v6.666h-3.334c-3.664,0-6.666,3.002-6.666,6.668V70h60V43.334 C80,39.668,76.999,36.666,73.333,36.666z M36.667,30c0-7.363,5.97-13.333,13.333-13.333S63.333,22.637,63.333,30v6.666H36.667V30z  M40,63.333h-6.666V50H40V63.333z M53.333,63.333h-6.666V50h6.666V63.333z M66.667,63.333H60V50h6.667V63.333z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.4ce10b18e4aa11cbf0336894b2ef1007.svg";
export { ForwardRef as ReactComponent };